import React from 'react';
import { useTranslation } from 'react-i18next';

import { Notification } from '@swyftx/aviary/atoms/Notification';
import { Body } from '@swyftx/aviary/atoms/Typography';

import { DateTime } from 'luxon';
import { useSwyftxMargin } from 'src/lib/margin/hooks/useSwyftxMargin';

type Props = {
  dismissible?: boolean;
};

const SwyftxMarginMaintenanceBanner: React.FC<Props> = ({ dismissible }) => {
  const { t } = useTranslation('margin');
  const { showDismissedMaintenanceBanner, setLastDismissedMaintenance, plannedMaintenance, isUnderMaintenance } =
    useSwyftxMargin();

  if ((dismissible && !showDismissedMaintenanceBanner) || !isUnderMaintenance || !plannedMaintenance) return null;

  return (
    <Notification
      severity='warning'
      dismissible={dismissible}
      onDismiss={() => setLastDismissedMaintenance(DateTime.now().toMillis())}
    >
      <Body size='small' className='mt-4'>
        {t('maintenance.content', {
          dateTime: DateTime.fromMillis(
            Math.max(plannedMaintenance?.updatedAt, plannedMaintenance?.startTime),
          ).toFormat('dd/MM/yyyy hh:mm a'),
        })}
      </Body>
    </Notification>
  );
};

export { SwyftxMarginMaintenanceBanner };
